import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface SupportWidgetStoreState {
  enabled: boolean;
  setEnabled: (enabled: boolean) => void;
}

export const useSupportWidgetStore = create<SupportWidgetStoreState>()(
  persist(
    (set) => ({
      enabled: false,
      setEnabled: (enabled) => set({ enabled })
    }),
    {
      name: 'assistantui:support-widget',
      partialize: (state) => ({ enabled: state.enabled })
    }
  )
);
